import React, { useRef, useState } from "react"
import styles from './Login.module.scss'
import { useAuth } from '../contexts/AuthContext';
import eventBus from "../utils/EventBus";
import ConfirmEmail from "./ConfirmEmail";

export default function VerifyEmail() {
    const emailRef = useRef();
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const { resendCode } = useAuth();

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        try {
            const email = emailRef.current.value;
            const result = await resendCode(email);

            if (!result.success) {
                setError(result.error);
            } else if (result.code === 'ALREADY_VERIFIED') {
                setMessage(result.message);
            } else {
                eventBus.publish('modal', {
                    title: "Confirm your email",
                    content: <ConfirmEmail email={email} justSent/>
                })
            }
        } catch (err) {
            setError('Failed to send verification code');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className={styles.login}>
            <form className={styles.form} onSubmit={handleSubmit}>
                <div>
                    <h3 className={styles.title}>Verify your email</h3>
                    {error && <div className={styles.error}>{error}</div>}
                    {message && <div className={styles.success}>{message}</div>}
                    <p>Enter your account email and we'll send you a new verification code.</p>
                    <label>Email</label>
                    <input ref={emailRef} type="email" placeholder="Enter Email" required/>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Sending...' : 'Send verification code'}
                    </button>
                </div>
            </form>
        </div>
    )
}
